import { render } from "./DRecordStatusIcon.vue?vue&type=template&id=2ffe9e61&scoped=true"
import script from "./DRecordStatusIcon.vue?vue&type=script&lang=js"
export * from "./DRecordStatusIcon.vue?vue&type=script&lang=js"

import "./DRecordStatusIcon.vue?vue&type=style&index=0&id=2ffe9e61&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffe9e61"]])

export default __exports__